import { lazy, ReactNode } from 'react'

const ProfileAssessmentCallbackPage = lazy(
  () => import('@pages/profile-assessment/profile-assessment-callback-page')
)

const ProfileAssessmentInProgressPage = lazy(
  () => import('@pages/profile-assessment/profile-assessment-in-progress-page')
)

export const makeProfileAssessmentCallbackPage = (): ReactNode => {
  return <ProfileAssessmentCallbackPage />
}

export const makeProfileAssessmentInProgressPage = (): ReactNode => {
  return <ProfileAssessmentInProgressPage />
}
